<template>
  <div v-if="filCrop == '' || filCrop == mygheom.crop_id" class="gheom-card-gheom gheom-card--thegheom"
    :class="spanSize">
    <div class="gheom__card__wrapper"
    :class="snakeLength">
      <div class="header">
        <div>
          <p class="name">{{mygheom.name}}  <span>{{this.gheomDuration}}</span></p>
          <p class="crop__content" :class="'c_'+mygheom.crop.logo_name">
            <span class="hide" v-if="isFinished">Finished Gheom</span>
            <span class="hide" v-else>Ongoing Gheom / {{mygheom.num_stages - mygheom.num_stages_finished}} times to go</span>
            <span>{{mygheom.crop.name}}</span>
          </p>
        </div>
        <div class="actions__chart">
          <div class="chart__cont">
            <circle-chart
              :currentvalue="this.mygheom.num_stages_finished"
              :totalvalue="this.mygheom.num_stages"
              :dim="36">
            </circle-chart>
          </div>
        </div>
      </div>
      <div class="content"
        >
        <div class="stages__actions hide">
          <ul>
            <li>
              <a href="#">
                <Plus/>
              </a>
            </li>
            <li>
              <a href="#">
                <Plus/>
              </a>
            </li>
          </ul>
        </div>
        <div class="stages__snakes">
          <ul>
            <li v-for="(dot, index) in this.dots" :key="index">
              <a href="#" :class="isPendingPhase(dot)">
                <p class="time--order">T{{dot.ti}}{{dot.which}}</p>
                <div class="time--lines">
                  <span class="line"></span>
                  <span class="line--helper"></span>
                  <span class="curve--helper"></span>
                </div>
                <p class="time--date" v-if="dot.date != null">{{ formatDate(dot.date) }}<span>{{ formatYear(dot.date) }} </span> </p>
                <p class="time--date" v-else>No date</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Shared from '../Shared'
import {Plus} from "lucide-vue-next";

export default {
  extends: Shared,
    components: {
        Plus
    },
  name: "gheom-card-gheom",
  props: [
    "mygheom", "filCrop"
  ],
  data:function(){ 
    return {
      show_tooltip: false
    }
  },
  computed: {
    gheomDuration: function() {
      let earliest = this.dots[0].date;
      let latest = this.dots[this.dots.length - 1].date; 
      let singleDur = "";
      if(moment(latest).diff(earliest, 'months') > 1) {
        singleDur = moment(latest).diff(earliest, 'months')+" months"
      } else {
        if(moment(latest).diff(earliest, 'days') == 0) {
          singleDur = ""
        } else {
          singleDur = moment(latest).diff(earliest, 'days')+" days";
        }
      }
      return singleDur;
    },

    shownStatus: function() {
      let theclass = "";
      (this.show_tooltip == true)? theclass = "tooltip--active" : theclass = "";
      return theclass;
    },

    snakeLength: function() {
      if(this.dots.length > 4) {
        return "big__snake";
      } else if (this.dots.length > 3) {
        return "medium__snake"
      } else {
        return "short__snake"
      }
    },

    isFinished: function() {
      if(this.mygheom.num_stages == this.mygheom.num_stages_finished) {
        return true
      }
    },

    spanSize: function () {
      var s = this.mygheom.num_stages;
      var theSpan = Math.ceil(s/4);

      let finished = "";

      if(this.isFinished) finished = " gheom--finished";

      if (s < 3) {
        return "span--s1" + finished
      } else if (s < 5) {
        return "span--m1" + finished
      } else {
        return "span--"+theSpan + finished
      }
    },

    dots: function() {
      function mygroupBy(arr, criteria) {
        var groupBy = function (arr, criteria) {
          return arr.reduce(function (obj, item) {

            // Check if the criteria is a function to run on the item or a property of it
            var key = typeof criteria === 'function' ? criteria(item) : item[criteria];

            // If the key doesn't exist yet, create it
            if (!obj.hasOwnProperty(key)) {
              obj[key] = [];
            }

            // Push the value to the object
            obj[key].push(item);

            // Return the object to the next item in the loop
            return obj;

          }, {});
        };

        let grouped = groupBy(arr, criteria)

        return grouped;
      }

      let dots = [];
      this.mygheom.stagedates.forEach((stage, stindex) => {
        // Transform array of stages in array of timestamps
        // We will group by date so in the end we will have an array of arrays, in each second-level array all the dots will share the date and the point and the different information will be displayed in the tooltip
        // Array of timestamps should be ordered from the past to the present
        if (stage.control_date == stage.treated_date) {
          let singleDot = {
            "date": stage.control_date,
            "finished": stage.finished,
            "ti": stage.time,
            "which": ""
          }
          dots.push(singleDot);
        } else {
          if(stage.control_date != null){
            let singleDotC = {
              "date": stage.control_date,
              "finished": stage.finished,
              "ti": stage.time,
              "which": "C"
            };
            dots.push(singleDotC);
          }

          if(stage.treated_date != null) {
          let singleDotT = {
            "date": stage.treated_date,
            "finished": stage.finished,
            "ti": stage.time,
            "which": "T"
          }
          dots.push(singleDotT);
          }
        }
      });

      dots = dots.sort(function(a,b){
        return new Date(b.date) - new Date(a.date);
      });

      dots = dots.sort(function(a,b){
        if(a.date == b.date) {
          return b.ti - a.ti
        } 
      })

      dots = dots.reverse();

      //let groupedDots = mygroupBy(dots, 'date');

      //let tempDots = Object.keys(groupedDots).map(i => groupedDots[i]); 
         
      return dots;
    }
  },
  methods: {
      formatDate (mydate) {
          return moment(mydate).format("DDMMM").toString()
      },

      formatYear (mydate) {
          return moment(mydate).format("YYYY")
      },
    showTooltip() {
      this.show_tooltip = true;
      this.$emit("activatetooltip")
    },

    isPendingPhase(st) {
      if (st.finished == false) {
        return "is--pending"
      }
    }
  },

}
</script>

